const SinglePicture = props => {
  const height = props.height === 320 ? 300 : 350;
  return `
<div class="${props.className.BIG_IMAGE}">
    <img id="qvh24-bigPic" src="${props.url.src}" alt="${
    props.url.alt
  }" style="height: ${height}px"/>
</div>
  `;
};

const PictureSlider = ({ className, images, height }) => {
  const farbe =
    (images.length <= 4 && height > 320) ||
    (images.length <= 3 && height === 320)
      ? 'white'
      : '#8e9597';
  const templatedImages = images.map((pic, index) => {
    const imgClass =
      index === 0
        ? className.SLIDER.INNERWRAP.IMG.ACTIVE
        : className.SLIDER.INNERWRAP.IMG.STANDARD;
    return `
<div class="${className.SLIDER.INNERWRAP.IMG.INNERWRAP}">
    <img data-bigpic="${pic.big.src}" 
        data-qvh24-pic-active="${index === 0}"
        id="qvh24-slider-img-${index}"
        class="${imgClass}"
        src="${pic.small.src}"
        alt="${pic.small.alt}"
    />
</div>
    `;
  });

  const sliderContent = `
<div class="${className.SLIDER.WRAP}" style="height: ${height}px">
    <div class="${className.SLIDER.ARROWUP}" style="color: ${farbe}"></div>
    <div class="${className.SLIDER.INNERWRAP.WRAP}">
        <div class="${className.SLIDER.INNERWRAP.IMG.WRAP}" >
            ${templatedImages}
        </div>
    </div>
    <div class="${className.SLIDER.ARROWDOWN}" style="color: ${farbe}"></div>
</div>
        `;

  return sliderContent.replace(/,/g, '');
};

const Pictures = ({ images, className, height }) => {
  return `
  ${PictureSlider({ images, className, height })}
  ${SinglePicture({ url: images[0].big, className, height })}
  `;
};

export default Pictures;



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/quickview/components/Pictures/pictures-ds-swiper.js
 **/